import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  ADD_REVIEW,
  DELETE_REVIEW,
  REVIEW_DETAILS,
  REVIEW_LIST,
  REVIEW_LIST_FOR_PRODUCTS,
  UPDATE_REVIEW,
} from "../actions/review.actions.types";
import History from "../services/history";

const call = Effects.call;

function* reviewList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: `reviews/list`,
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (callback) {
    callback({ success: !error, data: error ? null : result.data });
  }
}

function* reviewsForProduct({ payload: { id, data, callback } }) {
  const payload = {
    method: "get",
    url: `reviews/list?productId=${id}`,
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    callback({ success: !error, data: error ? null : result.data });
  }
}

function* reviewDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `reviews/details/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (callback) {
    callback({ success: !error, data: error ? null : result.data });
  }
}

function* addReview({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "reviews",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    successMessage(result.message);
    History.navigate("/reviews");
    if (callback) callback({ success: true, data: result.data });
  }
}

function* updateReview({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `reviews/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (!error) {
      successMessage(result.message);
      //   History.navigate("/reviews");
      callback({ success: true, data: result.data });
    } else {
      callback({ success: false, data: null });
    }
  }
}

function* deleteReview({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `reviews/${id}?force=true`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) callback({ success: false, data: null });
  } else {
    successMessage(result.message);
    if (callback) callback({ success: true, data: result.data });
  }
}

function* Review() {
  yield all([
    takeLatest(REVIEW_LIST, reviewList),
    takeLatest(REVIEW_DETAILS, reviewDetails),
    takeLatest(ADD_REVIEW, addReview),
    takeLatest(UPDATE_REVIEW, updateReview),
    takeLatest(DELETE_REVIEW, deleteReview),
    takeLatest(REVIEW_LIST_FOR_PRODUCTS, reviewsForProduct),
  ]);
}

export default Review;
